<!-- 最新动态 -->
<template>
  <div class="w-full flex flex-col gap-4 bg-gray py-3">
    <!-- 栏目标题 -->
    <div class="oneTitleDiv">
      <div class="oneTitle">
        <div class="pubTitle">
          <img :src="require('@/assets/title1.png')" alt="" width="22px" height="22px"/>
          <span style="margin-left: 8px;">{{ info?.label }}</span>
        </div>
        <div class="pubTitles">
          <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
          {{ info?.englishName }}
        </div>
      </div>
      <div class="oneMore" @click="handleNavigateToList(info?.id)">
        <img :src="require('@/assets/moreIconPro.png')" alt="" />
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="flex flex-col bg-gray px-4"
      v-for="item in videoInfoList"
      :key="item?.id"
      @click="() => handleNavigateToDetail(item?.id,item?.title)"
    >
      <!-- 图片 -->
      <div class="w-full h-52">
        <img
          @error="handleImageError"
          class="w-full h-full"
          :src="'/mainsys/UserFiles/menupic/' + item?.picUrl"
        />
      </div>
      <!-- 标题及描述 -->
      <div class="flex flex-col p-3 gap-1 bg-white">
        <span
          class="text-primary font-black text-base"
          :style="{
            color: '#13499B',
          }"
        >
          {{ item?.title }}
        </span>
        <span
          class="font-light"
          style="
            color: #333333;
            opacity: 0.6;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          "
        >
          {{ item?.descripton }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { array_ } from "../utils/index";
import mixins from "../hooks";

export default {
  name: "videoColumn",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },
  data() {
    return {
      acticveId: null,
    };
  },
  computed: {
    // 当前视频列表
    videoInfoList() {
      return array_(this.info?.newData.slice(0, 3));
    },
    // 当前视频id结合
    videoIDList() {
      return array_(this.videoInfoList).map(({ id }) => id);
    },
  },
  watch: {
    // 数据加载后,默认选中第一个
    videoIDList(val) {
      if (val.length) {
        this.acticveId = val[0];
      }
    },
  },
  methods: {
    handleImageError(e){
      e.target.src = require('../../../assets/2.png')
    },
    // 切换展示视频id | 如果点击已选中的视频则跳转
    handleChangeVideoId(id) {
      if (this.videoIDList.includes(id)) {
        if (this.acticveId === id) {
          this.handleNavigateToDetail(id);
        } else {
          this.acticveId = id;
        }
      }
    },
  },
};
</script>
<style scoped>
.oneTitleDiv {
  height: 70px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.oneTitle {
  width: 100%;
  background-size: 100% 100%;
  background: url("~@/assets/title.png") no-repeat;
  padding-left: 24px;
}
.pubTitle {
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  font-size: 18px;
  color: #176DAA;
  letter-spacing: 3.29px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: 14px;
}
.pubTitles {
  color: #176daa;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  margin-left: 14px;
  display: flex;
  align-items: center;
  margin-top: -4px;
}
.oneMore {
  cursor: pointer;
  position: absolute;
  right: 15px;
  bottom:0;
  height: 34px;
  width: 94px;
}
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 75% 100%;
}
</style>
